import { Pie } from 'react-chartjs-2'
import { Chart as ChartJS, ArcElement, Tooltip, Legend } from 'chart.js'
import { useEffect, useState } from 'react'

ChartJS.register(ArcElement, Tooltip, Legend)

const KpiCustomGraphicPie = ({
  data = {
    labels: ['Category 1', 'Category 2', 'Category 3'],
    datasets: [
      {
        data: [30, 50, 20],
        backgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
        hoverBackgroundColor: ['#FF6384', '#36A2EB', '#FFCE56'],
      },
    ],
  },
  options = {
    responsive: true,
    plugins: {
      legend: {
        position: 'top',
        labels: {
          color: '#000', // Add color to legend labels
        },
      },
      datalabels: {
        color: '#fff',
        font: {
          weight: 'bold',
        },
      },
      tooltip: {
        enabled: true,
      },
    },
  },
  fromPdf = false,
}) => {
    const [isMobile, setIsMobile] = useState(false)
  
    useEffect(() => {
      const handleResize = () => {
        if(!fromPdf){
          setIsMobile(window.innerWidth <= 768) // Detectar vista móvil
        }
      }
      handleResize()
      window.addEventListener('resize', handleResize)
      return () => window.removeEventListener('resize', handleResize)
    }, [])
  
    const optionsMobile = {
      ...options,
      plugins: {
        ...options?.plugins,
        legend: {
          ...options?.plugins?.legend,
          position: 'bottom',
          // Cambiar posición de la leyenda en móvil
        },
        datalabels: {
          ...options?.plugins?.datalabels,
          anchor: 'end',
          align: 'end',
          offset: -10, // Posicionar los valores dentro de las barras
          backgroundColor: 'rgba(0, 0, 0, 0.7)', // Fondo negro semi-transparente
          borderRadius: 4, // Bordes redondeados
          color: '#FFFFFF', // Color del texto
          padding: 4, // Espaciado interno
          font: {
            size: 10, // Tamaño pequeño de la letra
          },
        },
      },
    }

  return (
    <div className="px-1 kpi-graphics kpi-graphicsPie">
      <div className="row kpi-card-container kpi-card-containerMini">
        {data && options && <Pie data={data} options={isMobile ? optionsMobile : options} />}
      </div>
    </div>
  )
}

export default KpiCustomGraphicPie
